import type { TestimonialsSectionContent } from "@site-factory/config";
import type { BandedSectionVariant } from "../components/BandedSection";
import { TestimonialsSection } from "./TestimonialsSection";

/**
 * Lightweight alias of TestimonialsSection for product reviews/ratings.
 * Keeps the same content shape so it can drop into existing configs.
 */
export interface ReviewsSectionProps extends TestimonialsSectionContent {
  className?: string;
  bandVariant?: BandedSectionVariant;
}

export function ReviewsSection(props: ReviewsSectionProps) {
  return <TestimonialsSection {...props} />;
}
